module.exports = __webpack_public_path__ + "img/check-circle.f0a5fe0d.png";